module.exports = __webpack_public_path__ + "static/media/empty.894093da.svg";